export default function createCacheStorage() {
  const STORAGE = {};

  const WATCHERS = {};

  return {
    get(key) {
      if (this.has(key)) {
        return STORAGE[key].value;
      }

      return undefined;
    },

    getKeys() {
      return Object.keys(STORAGE);
    },

    has(key) {
      return key in STORAGE;
    },

    remove(key) {
      if (key in STORAGE) {
        delete STORAGE[key];
      }
    },

    removeAll(key) {
      const keys = this.getKeys();

      for (let i = 0; i < keys.length; i++) {
        if (keys[i].indexOf(key) === 0) {
          this.remove(keys[i]);
        }
      }
    },

    set(key, value) {
      STORAGE[key] = {
        value,
        time: new Date()
      };
    },

    update(key, updater) {
      if (typeof updater === 'function') {
        this.set(key, updater(this.get(key)));
      } else {
        this.set(key, updater);
      }

      const watchers = WATCHERS[key.split('/')[0]];

      if (watchers) {
        watchers.forEach(watcher => {
          watcher();
        });
      }
    },

    subscribe(name, callback) {
      if (!WATCHERS[name]) {
        WATCHERS[name] = [];
      }

      WATCHERS[name].push(callback);

      return () => this.unsubscribe(name, callback);
    },

    unsubscribe(name, callback) {
      if (WATCHERS[name]) {
        WATCHERS[name] = WATCHERS[name].filter(sub => sub !== callback);
      }
    }
  };
}
